import clsx from 'clsx';
import React from 'react';
import ContentLoader from 'react-content-loader';
import { theme } from '~/theme';
import styles from './Shimmer.module.scss';

type ShimmerProps = {
    className?: string;
};

/**
 * A pulsing placeholder that stretches to whatever shape it is given, so the skeleton around it
 * decides every size in CSS.
 */
export const Shimmer: React.FC<ShimmerProps> = ({ className }) => (
    <span className={clsx(styles.shimmer, className)}>
        <ContentLoader
            className={styles.loader}
            viewBox="0 0 1 1"
            preserveAspectRatio="none"
            speed={1}
            backgroundColor={theme.colors.grey10}
            foregroundColor={theme.colors.grey30}
        >
            <rect x="0" y="0" width="1" height="1" />
        </ContentLoader>
    </span>
);
